<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <div v-if="team.parent_id && !team.is_billable" class="max-w-(--breakpoint-sm)">
                <page-header>Billing Details</page-header>
                <vx-alert color="info" :closeable="false" data-test="parent-billing-alert">
                    Billing for this team is managed by your parent team.
                </vx-alert>
            </div>
            <page-loading v-else-if="!billing"></page-loading>
            <template v-else>
                <team-billing-details v-show="hash === 'billing-details' || !hash" :team="team" :billing="billing" />

                <team-proforma-invoices
                    v-if="team.status !== 'closed'"
                    v-show="hash === 'proforma-invoices'"
                    :teamId="team.id"
                    :paymentTermsDays="billing.payment_terms_days"
                />

                <team-historical-invoices v-show="hash === 'historical-invoices'" :teamId="team.id" />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import TeamBillingDetails from './TeamBillingDetails.vue';
import TeamProformaInvoices from './TeamProformaInvoices.vue';
import TeamHistoricalInvoices from './TeamHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, onMounted } from 'vue';
import { teamBillingClient } from '~/services';
import { useSettingsHash } from '~/composables/useSettingsHash';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';
import PageHeader from '~/components/general/PageHeader.vue';
import { VxAlert } from '@voxie/frontend-components';

const { hash, content } = useSettingsHash();
const toasted = useToasted();

const team = Spark.state.currentTeam;
const billing = ref(null);

onMounted(async () => {
    if (team.parent_id && !team.is_billable) {
        return;
    }

    try {
        const response = await teamBillingClient.getBillingDetails(team.id);
        billing.value = response.data;
    } catch (error) {
        toasted.error(catchRequestError(error));
    }
});
</script>
